import axios from 'axios';
import { config } from "./constants";
import { showError } from "./util";
import Cookies from "js-cookie";


export function getServerUrl() {
  return window.Liferay.OAuth2Client.FromUserAgentApplication(config.agentOauthAppId).homePageURL;
}

export async function getOAuthToken() {
  const cookieValue = Cookies.get("liferayToken");
  if (cookieValue) {
    const decodedToken = JSON.parse(cookieValue);
    if (window.Liferay.ThemeDisplay.getUserId() === decodedToken.userId) {
      return decodedToken.token;
    }
  }
  const prom = new Promise((resolve, reject) => {

    window.Liferay.OAuth2Client.FromUserAgentApplication(config.agentOauthAppId)
    ._getOrRequestToken()
    .then(
      (token) => {
        const tokenTTL = 30 * 60 * 1000;
        const tokenExpiryInDays = tokenTTL / (24 * 60 * 60 * 1000);
        const tokenValue = {
          token: token.access_token,
          userId: window.Liferay.ThemeDisplay.getUserId()
        };
        Cookies.set("liferayToken", JSON.stringify(tokenValue), {
          expires: tokenExpiryInDays,
          secure: true,
          sameSite: "Strict"
        });

        resolve(token.access_token);
      },
      (error) => {
        showError('Error', error);

        reject(error);
      }
    )
    .catch((error) => {
      showError('Error', error);

      reject(error);
    });
  });
  //console.log(prom)
  return prom;
}

export async function oAuthRequest(config) {
  const token = await getOAuthToken();
  return request({
    headers: {
      Authorization: `Bearer ${token}`
    },
    ...config
  });
}

export function request(config) {
  return new Promise((resolve, reject) => {
    axios
    .request({
      headers: {
        'x-csrf-token': window.Liferay.authToken || null
      },
      method: 'get',
      ...config
    })
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      reject(error);
    });
  });
}